import { Button } from '@bambi/component-library/src/components/Button';

import { DataGrid } from 'src/common/DataGrid';

import {
  bulkPriceTripNoPricingSchemeResultsColumns,
  bulkPriceTripResultsColumns,
} from './columns';
import { useConfirmPriceStepViewModel } from './useConfirmPriceStepViewModel';

interface ConfirmPriceStepProps {
  setOpen: (open: boolean) => void;
  setError: (error: string | null) => void;
}

export const ConfirmPriceStep = ({
  setOpen,
  setError,
}: ConfirmPriceStepProps) => {
  const {
    bulkPriceResults,
    getRowId,
    handleSubmit,
    loading,
    selectedBulkPriceTripRowsAsBoolean,
    setRowSelection,
    tableClass,
  } = useConfirmPriceStepViewModel(setOpen, setError);

  return (
    <div>
      {bulkPriceResults.trips_repriced.length > 0 && (
        <div className="my-4">
          <h2 className="text-lg">Trips to Price</h2>
          <p className="pb-4 text-sm">
            The following trips will be priced. Unselect trips if you don't want
            to price them.
          </p>
          <DataGrid
            tableId="bulk-price-trips-results-table"
            rowSelection={selectedBulkPriceTripRowsAsBoolean}
            setRowSelection={
              setRowSelection as React.Dispatch<
                React.SetStateAction<Record<string | number | symbol, boolean>>
              >
            }
            containerClassName={tableClass}
            data={bulkPriceResults.trips_repriced}
            columns={bulkPriceTripResultsColumns}
            includePagination={false}
            dataTestId="bulk-price-trips-results-table"
            getRowId={getRowId}
          />
        </div>
      )}

      {bulkPriceResults.trips_no_pricing_scheme.length > 0 && (
        <div className="mb-4">
          <h2 className="text-lg">Trips With No Pricing Scheme</h2>
          <p className="pb-4 text-sm">
            The following trips have no pricing scheme:
          </p>

          <DataGrid
            tableId="trips-no-pricing-scheme-table"
            containerClassName={tableClass}
            data={bulkPriceResults.trips_no_pricing_scheme}
            columns={bulkPriceTripNoPricingSchemeResultsColumns}
            includePagination={false}
            dataTestId="trips-no-pricing-scheme-table"
          />
        </div>
      )}

      <div className="flex flex-row justify-end gap-4 pt-6">
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button
          loading={loading}
          variant="primary"
          onClick={() => handleSubmit()}
          disabled={!bulkPriceResults.trips_repriced.length}
        >
          {loading ? 'Saving...' : 'Accept Price Changes'}
        </Button>
      </div>
    </div>
  );
};
